const electionsOptions = [
  { id: 1, name: 'Vereador', is_municipal: true, },
  { id: 2, name: 'Prefeito', is_municipal: true, },
];

export default electionsOptions;
